export function setIsActive(_ref, data) {
  var commit = _ref.commit;
  commit('SET_IS_ACTIVE', data);
}
export function setDialogOpen(_ref2, data) {
  var commit = _ref2.commit;
  commit('SET_DIALOG_OPEN', data);
}